<div class="backDrop" *ngIf="visible" title="">
	<div class="modal-dialog modal-s">
		<div class="modal-content">
			<div>
				<div class="modal-header ">
					<h4 class="modal-title">Linked help articles</h4>
				</div>

				<div class="modal-body">
					<p class="text-muted" *ngIf="applicationName">
						Configure help articles for <strong>{{ applicationName }}</strong>.
					</p>

					<div class="form-group">
						<label for="adminLoginFreshdeskArticleIds">Freshdesk Article ID(s)</label>
						<input
							id="adminLoginFreshdeskArticleIds"
							type="text"
							class="form-control"
							[(ngModel)]="articleIdsText"
							[ngModelOptions]="{ standalone: true }"
							placeholder="e.g. 103000374329 or 103000374329, 103000374330"
						/>
						<small class="form-text text-muted">
							Comma or space separated. Leave blank to remove all linked articles.
						</small>
					</div>
				</div>

				<div class="modal-footer">
					<button [disabled]="saving" type="button" class="btn btn-success" (click)="save()">
						Save
					</button>
					<button [disabled]="saving" type="button" class="btn btn-primary" (click)="close()">
						Cancel
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
